import { formSchema } from '../../validaciones/validacionCanchas';
import { apiFetch } from '../../utils/api';

const obtenerSucursalSeleccionada = (sucursales) => Array.isArray(sucursales) ? sucursales[0] : sucursales;

const mostrarAlerta = (message) => {
    if (window.notie?.alert) {
        window.notie.alert({ type: "warning", text: message, time: 4 });
    } else {
        window.alert(message);
    }
};

const subirLogoCancha = async (multiImagenes) => {
    const imagenNueva = Array.isArray(multiImagenes) ? multiImagenes.find((image) => image.esNuevo && image.file) : null;
    if (!imagenNueva) return {};

    const formData = new FormData();
    formData.append('logo', imagenNueva.file);
    const data = await apiFetch('/api/courts/upload-logo', {
        method: 'POST',
        body: formData,
    });

    if (!data.status) {
        throw new Error(data.message || 'No se pudo subir la imagen de la cancha.');
    }

    return {
        logoUrl: data.data?.url || null,
        logoKey: data.data?.key || null,
    };
};

const crearPayloadCancha = (datos, logoData = {}) => {
    const sucursalSeleccionada = obtenerSucursalSeleccionada(datos.sucursales);
    return {
        branchId: sucursalSeleccionada?.value,
        nombre: datos.nombre,
        construccion: datos.construccion,
        tiempoUso: datos.tiempoUso === '' || datos.tiempoUso === null || datos.tiempoUso === undefined
            ? null
            : Number(datos.tiempoUso),
        activo: Boolean(datos.activo),
        ...logoData,
    };
};

export const formularioCanchasSlice = (set,get) => ({
    construcciones: [
        {value:"Outdoor",label:"Outdoor"},
        {value:"Indoor",label:"Indoor"}
    ],
    handleChange: (e) => set({ datos:{ ...get().datos, [e.target.name]: e.target.value } }),
    handleSave: async () => {

        const result = formSchema.safeParse({ ...get().datos, multiImagenes: get().multiImagenes });
        if (!result.success) {
            console.log(result.error.errors);
            console.log(result.error.flatten().fieldErrors);
            set({error:result.error.flatten().fieldErrors})
            return;
        }
        else{
            set({error:null})
        }

        set({ isLoading: { ...get().isLoading, guardarCancha: true } });
        try {
            const logoData = await subirLogoCancha(get().multiImagenes);
            const payload = crearPayloadCancha(get().datos, logoData);
            const isNew = String(get().datos.id) === "0";
            const data = await apiFetch(isNew ? "/api/courts" : `/api/courts/${get().datos.id}`,{
                method: isNew ? "POST" : "PUT",
                body: JSON.stringify(payload)
            });
            console.log(data);
            if(data.status){
                get().elNavigate(-1);
            } else {
                mostrarAlerta(data.message || "No se pudo guardar la cancha.");
            }
        } catch (error) {
            console.error('Error:', error);
            mostrarAlerta(error.message || "No se pudo guardar la cancha.");
        } finally {
            set({ isLoading: { ...get().isLoading, guardarCancha: false } });
        }
    },
    obtenerCancha: async () => {
        if(String(get().datos.id) !== "0"){
            try {
                const data = await apiFetch(`/api/courts/${get().datos.id}`,{
                method: "GET",
                });
                console.log('CANCHA',data.data, get().sucursales);
                if(data.status){
                    const sucursal = get().sucursales.find((item) => item.value === data.data.branchId) || null;
                    set({datos:{
                        ...get().datos,
                        nombre:data.data.nombre,
                        construccion:data.data.construccion || "Outdoor",
                        tiempoUso:data.data.tiempoUso === null || data.data.tiempoUso === undefined ? "90" : String(data.data.tiempoUso),
                        sucursales:sucursal,
                        activo:Boolean(data.data.activo)
                    }});

                    const imagenesCanchas = data.data.logoUrl ? [{
                            id:data.data.id,
                            nombre:data.data.logoKey || data.data.logoUrl,
                            file:null,
                            esNuevo:false,
                            preview:data.data.logoUrl,
                    }] : [];

                    console.log('imagenesCanchas',imagenesCanchas);
                    set({multiImagenes:imagenesCanchas});
                    set({isLoading:{cargarSucursalCategoria: false, cargarCancha: false}});
                } else {
                    mostrarAlerta(data.message || "No se pudo cargar la cancha.");
                    set({isLoading:{cargarSucursalCategoria: false, cargarCancha: false}});
                }
            } catch (error) {
                console.error('Error:', error);
                mostrarAlerta(error.message || "No se pudo cargar la cancha.");
                set({isLoading:{cargarSucursalCategoria: false, cargarCancha: false}});
            }
        }
        else{
            set({isLoading:{cargarSucursalCategoria: false, cargarCancha: false}});
        }
    }
})
